<template>
  <Card
    class="data-card"
    shadow="hover"
  >
    <!-- 维度描述 -->
    <div class="data-card-header">
      <span>{{ name }}</span>
      <div>
        <i
          v-if="config.setting"
          class="el-icon-setting data-card-setting"
          @click="handleSettingClick"
        ></i>
        <Description :dataSource="nameDesc">
          <i class="el-icon-question"></i>
        </Description>
      </div>
    </div>

    <!-- 数据 -->
    <div
      class="data-card-value"
      @click="handleNumClick(dataSource)"
    >
      {{ num | currencyNumber }}
    </div>

    <!-- 环比 -->
    <div class="data-card-rate">
      <Description :dataSource="rateDesc">
        <span class="data-card-label">环比</span>
      </Description>

      <i
        v-if="icon"
        :class="{
          [`el-icon-caret-${icon}`]: true,
          [`crm-rate-${icon}`]: true,
        }"
      ></i>
      <span>{{ rate }}</span>
    </div>

    <div class="data-card-divider"></div>

    <!-- 消耗 -->
    <div class="data-card-cost">
      <Description :dataSource="costDesc">
        <span class="data-card-label">消耗额</span>
      </Description>

      <span class="data-card-cost-value">{{ cost | currencyMoney }}</span>
    </div>
  </Card>
</template>

<script>
import { Card } from 'element-ui';

import Description from '../Description/Index';

import config from './config';

export default {
  components: {
    Card,

    Description,
  },

  props: {
    dataSource: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      visible: false,
      config: config[this.dataSource.key] || {},
    }
  },

  computed: {
    name() {
      return this.dataSource.name || '-';
    },

    nameDesc() {
      return this.config.name || [];
    },

    num() {
      return this.dataSource.num.toString() || '';
    },

    rate() {
      const { rate } = this.dataSource;
      return rate ? rate.replace('-', '') : '';
    },

    rateDesc() {
      return this.config.rate || [];
    },

    cost() {
      return this.dataSource.cost || '';
    },

    costDesc() {
      return this.config.cost || [];
    },

    // 判断比例是上升还是下降
    icon() {
      const { rate } = this.dataSource;
      if (!rate) return '';
      return rate.indexOf('-') !== -1 ? 'bottom' : 'top';
    },
  },

  methods: {
    // 点击停投配置
    handleSettingClick() {
      this.$emit('setting-click');
    },

    // 点击数值
    handleNumClick(dataSource) {
      this.$emit('num-click', dataSource);
    }
  }
}
</script>

<style lang="less" scoped>
.data-card {
  width: 300px;
  font-size: 14px;
  color: #909399;

  &-header {
    display: flex;
    justify-content: space-between;

    i:hover {
      color:#2f9eff;
      cursor: pointer;
    }
  }

  &-label {
    cursor: pointer;
  }

  &-setting {
    margin-right: 10px;
  }

  &-value {
    font-size: 30px;
    font-weight: bold;
    color: #2f9eff;
    margin-top: 10px;
    cursor: pointer;
    user-select: none;
  }

  &-rate {
    margin-top: 10px;

    & > i {
      margin-left: 10px;
      margin-right: 4px;
    }
  }

  &-divider {
    width: 100%;
    height: 1px;
    background: #e8e8e8;
    margin-top: 20px;
  }

  &-cost {
    display: flex;
    margin-top: 10px;

    &-value {
      margin-left: 10px;
    }
  }
}
</style>